import MtsDosyaBilgileri from "./parser/Mts/MtsDosyaBilgileri";
import TakipInjectable from "./parser/TakipInjectable";
import {Mixins} from "./Mixins";
import Args from "./parser/Args";
import TarafKisi from "./parser/TarafKisi";
import TarafKurum from "./parser/TarafKurum";
import Taraf from "./parser/Taraf";
import MtsDiger from "./parser/Mts/MtsDiger";
import MtsIlamsizParser from "./parser/Mts/MtsIlamsizParser";
import {MtsDosyaFormData} from "./MtsDosyaFormData";
import app from "@/main";
import Crypto from "crypto";
import {eksikRolHatasi, eksikRoller, tarafsizKalemHatasi, tarafTakibeDahilMi} from "./TakibeDahilTaraf";

export interface MtsBelge {
    id: any,
    faturaId: any,
    acikTutar: any,
    odemeTarihi: string,
    faturaTarihi: string,
    tutarAdi: string,
}

export class MtsXmlParser extends TakipInjectable {
    dosyaNode !: HTMLUnknownElement;
    formData!: MtsDosyaFormData;
    args: Args = new Args();
    mtsDosyaBilgileri!: MtsDosyaBilgileri;
    tarafList: Array<TarafKisi | TarafKurum> = [];
    belgeList: MtsBelge[] = [];
    ilamsizList: MtsDiger[] = [];
    selectedTarafHashKeyList: string[] = []
    toplamTakibeEsasMiktar: number = 0;
    harcMasrafToplam: number = 0;
    hash: string = '';
    hashObj: any;

    static fromJson(jsonData: any): MtsXmlParser {
        let obj = Args.staticFromJson(jsonData,new MtsXmlParser());
        obj.mtsDosyaBilgileri = MtsDosyaBilgileri.fromJson(jsonData.mtsDosyaBilgileri);
        obj.tarafList = jsonData.tarafList.map((taraf: any) => {
            return Taraf.fromJson(taraf, true);
        });
        obj.ilamsizList = jsonData.ilamsizList.map((diger: any) => {
            return MtsDiger.fromJson(diger);
        })
        return obj;
    }

    static async parse(dosyaNode: HTMLUnknownElement, formData: MtsDosyaFormData): Promise<MtsXmlParser> {
        try {
            let parser = new MtsXmlParser();
            parser.dosyaNode = dosyaNode;
            parser.formData = formData;

            //MDB.adliyeler
            //parser.formData.birimAd = formData.adliyeler.find(adliye=>adliye.adliyeBirimID == formData.adliye).adliyeIsmi;

            await parser.setEvraklar(parser.dosyaNode);
            parser.parseAndSetBelgeler();
            await parser.setDayanakFromAlacakBelgePath();

            parser.mtsDosyaBilgileri = MtsDosyaBilgileri.parse(parser.dosyaNode, parser.formData);
            parser.args.icraproXmliMi = parser.mtsDosyaBilgileri.isIcraProXml();
            await parser.setTaraflar();
            parser.ilamsizList = MtsIlamsizParser.parse(
                parser.dosyaNode.querySelectorAll('digerAlacak'),
                parser.belgeList,
                parser.tarafList,
                parser.args
            );
            parser.takibeEsasMiktarTopla();
            //this.setHashData(true , this.mtsDosyaBilgileri.dosyaBelirleyici.id);
            parser.generateXmlHash();
            return Promise.resolve(parser);
        } catch (e) {
            return Promise.reject(e);
        }

    }

    async setTaraflar() {
        for (let node of this.dosyaNode.querySelectorAll('taraf')) {
            let taraf = await Taraf.parse(node, [], this.formData, true);
            this.tarafList.push(taraf)
        }
    }

    parseAndSetBelgeler() {
        // <belge id="fatura_191000206" faturaId="20210401740523" acikTutar="107.9" odemeTarihi="20/05/2021" faturaTarihi="30/04/2021" tutarAdi="TL - Türk Lirası" aciklama=" " />
        let belgeler = this.dosyaNode.querySelectorAll('belgeler belge');
        belgeler.forEach(node => {
            this.belgeList.push({
                id: Mixins.onlyDigit(node.getAttribute("id")),
                faturaId: node.getAttribute("faturaid"),
                acikTutar: Mixins.nullUndefCleaner(node.getAttribute("aciktutar")),
                odemeTarihi: Mixins.tarihConverter(node.getAttribute("odemetarihi")),
                faturaTarihi: Mixins.tarihConverter(node.getAttribute("faturatarihi")),
                tutarAdi: Mixins.nullUndefCleaner(node.getAttribute("tutaradi"))
            });
        })
    }

    async setDayanakFromAlacakBelgePath(): Promise<void> {
        try {
            let alacakBelgePath = Mixins.nullUndefCleaner(this.dosyaNode.getAttribute("alacakbelge"));
            // alacakBelge="C:\Faturalar\MTS_CASE_OPENING_202201181077234757..pdf"
            console.log("alacakBelgePath", alacakBelgePath);
            console.log("dosyaNode", this.dosyaNode);
            if (alacakBelgePath != "") {
                let belge = await app.$imza.getFileFromLocalPath(alacakBelgePath);
                console.log("BELGEEEE ------", belge);
                let splited = alacakBelgePath.replace(/\\/g, "/").split("/");
                let fileName = splited[splited.length - 1];
                let evrak = {
                    data: belge.file,
                    mimeType: Mixins.findFileMimeType(fileName),
                    name: fileName
                };
                console.log("alacakBelge To Dayanak", evrak);
                this.dayanaklar.push(evrak);
            }
        } catch (e) {
            console.log("AlacakBelge Eklenemedi ", e);
        }
    }

    generateXmlHash() {
        let hashObj: any = {
            type: "mts",
            taraflar: [],
            takibeEsasMiktar: this.toplamTakibeEsasMiktar,
        };
        this.tarafList.forEach(taraf => {
            console.log("TARAF", taraf);
            if (taraf.isKisi()) {
                hashObj.taraflar.push({
                    ad: taraf.temelBilgileri.adi,
                    soyad: taraf.temelBilgileri.soyadi,
                    tcKimlikNo: taraf.temelBilgileri.tcKimlikNo,
                    rolId: taraf.tarafSifati.rolID
                })
            }
            if (taraf.isKurum()) {
                hashObj.taraflar.push({
                    kurumadi: taraf.temelBilgileri.kurumAdi,
                    vergino: taraf.temelBilgileri.vergiNo,
                    mersisno: taraf.temelBilgileri.mersisNo,
                    rolId: taraf.tarafSifati.rolID
                })
            }
        })
        this.hashObj = hashObj;
        this.hash = Crypto.createHash('sha1').update(JSON.stringify(hashObj)).digest().toString('hex');
    }

    /**
     * DEV-4317: Tiki kaldırılan (ve sorguda takibe alınmayan) tarafları listeden çıkarır.
     * MTS'de taraflar `kisi_N` / `kurum_N` anahtarıyla gösterilir; N kişi ve kurum listesindeki
     * sıradır. Kalemlerin anahtarları kalan listeye göre yeniden yazılır. Tekrar çağrılması
     * zararsızdır. Bir kalemin bütün tarafları çıkarılıyorsa hiçbir şeyi değiştirmeden hata atar.
     * Liste değiştiyse true döner.
     */
    secilmeyenTaraflariCikar(): boolean {
        const plan = this.tarafSecimPlani();
        if (!plan)
            return false;
        if (plan.tarafsizKalanlar.length > 0)
            throw tarafsizKalemHatasi(plan.tarafsizKalanlar);
        if (plan.eksikRoller.length > 0)
            throw eksikRolHatasi(plan.eksikRoller);
        plan.uygula();
        return true;
    }

    /** Seçim uygulanınca bütün tarafları çıkmış olacak alacak kalemlerinin adları (değişiklik yapmaz). */
    tarafsizKalacakKalemler(): string[] {
        return this.tarafSecimPlani()?.tarafsizKalanlar || [];
    }

    private tarafSecimPlani(): { tarafsizKalanlar: string[], eksikRoller: string[], uygula: () => void } | null {
        const eskiList = this.tarafList || [];
        const yeniList = eskiList.filter(taraf => tarafTakibeDahilMi(taraf));
        if (yeniList.length == eskiList.length)
            return null;

        const anahtar = (liste: Array<TarafKisi | TarafKurum>, taraf: TarafKisi | TarafKurum): string => {
            const kisiMi = taraf.isKisi();
            const ayniTur = liste.filter(t => t.isKisi() === kisiMi);
            return (kisiMi ? "kisi_" : "kurum_") + ayniTur.indexOf(taraf);
        };
        const yeniAnahtar: Record<string, string> = {};
        eskiList.forEach(taraf => {
            if (yeniList.indexOf(taraf) >= 0)
                yeniAnahtar[anahtar(eskiList, taraf)] = anahtar(yeniList, taraf);
        });

        const kalemler: any[] = [];
        (this.ilamsizList || []).forEach(ilamsiz => kalemler.push(...((ilamsiz?.alacakKalemleri || []).filter(k => !!k))));
        const degisimler = kalemler
            .map(kalem => {
                const eski: string[] = kalem.selectedTarafHashKeyList || [];
                return {kalem, eski, yeni: eski.filter(a => !!yeniAnahtar[a]).map(a => yeniAnahtar[a])};
            })
            .filter(x => x.eski.length > 0);

        return {
            eksikRoller: eksikRoller(yeniList),
            tarafsizKalanlar: degisimler
                .filter(x => x.yeni.length == 0)
                .map(x => x.kalem.temelBilgiler?.aciklama || "Alacak kalemi"),
            uygula: () => {
                degisimler.forEach(x => x.kalem.selectedTarafHashKeyList = x.yeni);
                this.tarafList = yeniList;
            }
        };
    }

    takibeEsasMiktarTopla() {
        this.toplamTakibeEsasMiktar = 0;
        this.ilamsizList.forEach(ilamsiz => {
            let deleteKeyList: any = [];
            ilamsiz.alacakKalemleri.forEach((alacakKalemi, key) => {
                if (alacakKalemi === null) {
                    //tutar 0  esit veya kucukse null geliyor
                    deleteKeyList.push(key);
                } else {
                    this.toplamTakibeEsasMiktar += parseFloat(alacakKalemi.temelBilgiler.tutarTL)
                }
            });
            deleteKeyList.forEach((index: any) => {
                ilamsiz.alacakKalemleri.splice(index, 1);
            })
        })
    }

    /**
     * Toplam takibe esas miktarı formatlanmış string olarak döndürür
     */
    getToplamTakibeEsasMiktarText(): string {
        if (!this.toplamTakibeEsasMiktar) return '-';
        try {
            return new Intl.NumberFormat('tr-TR', {
                style: 'currency',
                currency: 'TRY',
            }).format(this.toplamTakibeEsasMiktar);
        } catch (e) {
            console.error('Currency formatting error:', e);
            return '-';
        }
    }
}